<template>
  <!-- 面包屑导航-->
  <div class="breadcrumb">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item v-for="(item,index) in breadCrumbList" :key="item.name"
                          :to="index<=breadCrumbList.length ? { path: item.path } : ''">
        {{ item.name }}
      </el-breadcrumb-item>
    </el-breadcrumb>
    <span v-if="suffix" class="suffix">{{ suffix }}</span>
    <span v-if="dsOrder" class="suffix">{{ dsOrder }}</span>
  </div>
</template>

<script>
import {useStore} from '../../store'

const store = useStore()
export default {
  name: 'custom-breadcrumb',
  props: {
    suffix: {
      type: String,
      default: ''
    },
    dsOrder: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  computed: {
    breadCrumbList: () => {
      return store.breadCrumbList
    }

  }
}
</script>

<style scoped>
.breadcrumb {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  user-select: none;
  flex-wrap: wrap;
  min-width: 800px;
}
/deep/ .el-breadcrumb__inner{
  font-size: 14px;
  color: #8f8f8f;
  font-weight: 700;
}
/deep/ .el-breadcrumb__item:last-child .el-breadcrumb__inner{
  color: #262B2F;
  font-size: 14px;
  font-weight: 800 !important;
  font-family: Graphik;
}
.suffix{
  margin: 0px 20px;
  font-size: 14px;
  font-family: Graphik;
  font-weight: 800;
  color: #262B2F;
  word-break:initial;
}
</style>



// WEBPACK FOOTER //
// src/pages/components/custom-breadcrumb.vue